import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  private cartUpdatedSource = new BehaviorSubject<boolean>(false);
  cartUpdated$ = this.cartUpdatedSource.asObservable();
  public purchaseCompleted$ = new BehaviorSubject<{ success: boolean, nftIds?: any[] } | null>(null);

  constructor(private http: HttpClient) {}

/**
 * Emits a cart update event, which can be subscribed to using the cartUpdated$ observable.
 * This can be used to trigger a refresh of the cart items in a component, for example.
 */
  emitCartUpdate() {
    this.cartUpdatedSource.next(true);
  }

/**
 * Adds item to cart
 * @param params object containing item id and quantity
 * @returns observable containing response from server
 */
  addCart(params: any): Observable<any> {
    return this.http.post(`${environment.API_BASE_URL_V3}/bundle-purchase/add-item-to-cart`, params);
  }
  
/**
 * Retrieves items in cart
 * @returns observable containing response from server
 */
  getCart(): Observable<any> {
    return this.http.get(`${environment.API_BASE_URL_V3}/bundle-purchase/get-cart-items`);
  }
  
/**
 * Removes item from cart
 * @param itemId the id of the item to be removed from the cart
 * @returns observable containing response from server
 */
  removeCart(itemId: string): Observable<any> {
    return this.http.delete(`${environment.API_BASE_URL_V3}/bundle-purchase/remove-item-from-cart?id=${itemId}`);
  }
}
